

export class ScheduleSegment {
  id: number;
  start_time: Date
  end_time: Date
  entry_id: number

  constructor() {
    this.id = -1;
    this.start_time = new Date();
    this.end_time = new Date();
    this.entry_id = -1;
  }
}
